import { Route, Routes } from 'react-router-dom'
import * as routes from '../../routes'
import EventStage from '../events/EventStage'
import RegistrationStage from '../registrations/RegistrationStage'
import ParticipantStage from '../participant/ParticipantStage'
import PaymentStage from '../payment/PaymentStage'
import VerifyStage from '../verify/VerifyStage'
import SuccessStage from '../success/SuccessStage'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { Col, Container, Row } from 'react-bootstrap'
import { IProgram } from '../../store/program/interfaces'
import { isTabletOrMobileQuery } from '../../utils'
import { useMediaQuery } from 'react-responsive'

const renderTopAd = (program: IProgram) => {
  let content = <></>
  if (program.ad_top_img) {
    content = (
      <Row>
        <Col className='mb-2'>
          {program.ad_top_link ? (
            <a
              href={program.ad_top_link}
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src={program.ad_top_img}
                className='img-fluid mx-auto d-block'
                alt='Oberes Werbebanner'
              />
            </a>
          ) : (
            <img
              src={program.ad_top_img}
              className='img-fluid mx-auto d-block'
              alt='Oberes Werbebanner'
            />
          )}
        </Col>
      </Row>
    )
  }
  return content
}

const renderLeftAd = (program: IProgram, isTabletOrMobile: boolean) => {
  let content = <></>
  if (program.ad_left_img && !isTabletOrMobile) {
    content = (
      <Col md={2}>
        {program.ad_left_link ? (
          <a
            href={program.ad_left_link}
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={program.ad_left_img}
              className='img-fluid mx-auto d-block'
              alt='Linkes Werbebanner'
            />
          </a>
        ) : (
          <img
            src={program.ad_left_img}
            className='img-fluid mx-auto d-block'
            alt='Linkes Werbebanner'
          />
        )}
      </Col>
    )
  }
  return content
}

const renderRightAd = (program: IProgram, isTabletOrMobile: boolean) => {
  let content = <></>
  if (program.ad_right_img && !isTabletOrMobile) {
    content = (
      <Col md={2}>
        {program.ad_right_link ? (
          <a
            href={program.ad_right_link}
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={program.ad_right_img}
              className='img-fluid mx-auto d-block'
              alt='Linkes Werbebanner'
            />
          </a>
        ) : (
          <img
            src={program.ad_right_img}
            className='img-fluid mx-auto d-block'
            alt='Linkes Werbebanner'
          />
        )}
      </Col>
    )
  }
  return content
}

// Structure content in relation to potential ads
const ContentStructure = () => {
  const { data: program } = useSelector((state: RootState) => state.program)
  const isTabletOrMobile = useMediaQuery(isTabletOrMobileQuery)
  // const location = useLocation()
  return (
    <Container id='main-content' className={`${program.ad_left_img || program.ad_right_img ? 'mx-2' : ''}`} fluid>
      {renderTopAd(program)}
      <Row>
        {renderLeftAd(program, isTabletOrMobile)}
        <Col>
          <Container className={`${program.ad_left_img || program.ad_right_img ? 'mw-100' : ''}`} id='main-container'>
            <Routes>
              <Route
                path='/'
                //element={() => redirect(`${routes.EVENTS.path}#${location.hash}`)}
              />
              <Route
                path={routes.EVENTS.path + '/:eventId?'}
                element={<EventStage />}
              />
              <Route
                path={routes.REGISTRATIONS.path + '/:eventId?'}
                element={<RegistrationStage />}
              />
              <Route
                path={routes.PARTICIPANT.path}
                element={<ParticipantStage />}
              />
              <Route path={routes.PAYMENT.path} element={<PaymentStage />} />
              <Route
                path={routes.VERIFY.path + '/:eventId?'}
                element={<VerifyStage />}
              />
              <Route path={routes.SUCCESS.path} element={<SuccessStage />} />
            </Routes>
          </Container>
        </Col>
        {renderRightAd(program, isTabletOrMobile)}
      </Row>
    </Container>
  )
}

export default ContentStructure
